<template>
  <div>
    <h2>503 Service Unavailable</h2>
    <p>Woops! It looks like something may have been temporarily down. Try reloading this page.</p>
    <p>
      If the problem persists, check our
      <a href="https://twitter.com/getdonedone">Twitter page</a>
      for service interruption updates or send us a note with the URL you
      are trying to access to our
      <a
        href="https://www.donedone.com/help-center"
      >Support Center</a>.
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ServiceUnavailable',
})
</script>
